import { Component, inject } from '@angular/core';
import { ModalBaseComponent } from '../../../shared/components/modal-base/modal-base.component';
import { PrivateBookingMainFormComponent } from '../private-booking-main-form/private-booking-main-form.component';
import {
  BookingsDisplayMode,
  BookingsScope,
} from '../../../core/store/bookings/bookings.state';
import { parseISO } from 'date-fns';
import { ModalService } from '../../../core/services/modal.service';
import { Store } from '@ngrx/store';
import { bookingsActions } from 'angular/app/core/store/bookings';
import { selectFocusedBooking } from '../../../core/store/reducers';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-personal-bookings-modal',
  template: `
    <app-modal [modalInstance]="modalInstance">
      <div class="mb-6 flex justify-end md:mb-10">
        <app-button icon="plus" (click)="createPrivateBooking()"
          >{{ 'common.button.add' | transloco }}</app-button
        >
      </div>
      <app-bookings-list [scope]="BookingsScope.Personal"></app-bookings-list>
    </app-modal>
  `,
  standalone: false,
})
export class PersonalBookingsModalComponent extends ModalBaseComponent {
  BookingsScope = BookingsScope;
  private modalService = inject(ModalService);
  private store = inject(Store);
  private translocoService = inject(TranslocoService);

  booking = this.store.selectSignal(selectFocusedBooking);

  constructor() {
    super();
  }

  createPrivateBooking() {
    const instance = this.modalService.open(PrivateBookingMainFormComponent, {
      title: this.translocoService.translate('bookings.personal-modal.add-private-booking-title'),
      size: 'screen',
    });
    (
      instance.componentRef.instance as PrivateBookingMainFormComponent
    ).bookingSaved.subscribe(() => {
      this.store.dispatch(
        bookingsActions.setDisplayMode({
          displayMode: BookingsDisplayMode.Week,
          scope: BookingsScope.Personal,
        }),
      );
      this.store.dispatch(
        bookingsActions.setCalendarDate({
          date: parseISO(this.booking().start),
          scope: BookingsScope.Personal,
        }),
      );
    });
  }
}
